import React, { useState, useEffect } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import * as Common from '../Common';

function TransactionComment(props) {
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [commentList, setCommentList] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);

    useEffect(() => {
        if (props.rc !== refreshCounter) {
            setOnceRun(false);
        }
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiComment, [sid, 'listjson', props.srno], function (result) {
                setCommentList(JSON.parse(result));
            });
            setOnceRun(true);
        }
        setRefreshCounter(props.rc);
    }, [onceRun, sid, props, refreshCounter]);

    return (
        <>
            <Row>
                <Col>
                    <h5>Comments</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive >
                        <thead>
                            <tr>
                                <td>Time Stamp</td>
                                <td>User</td>
                                <td>Remark</td>
                            </tr>
                        </thead>
                        <tbody>
                            {commentList.map((res) =>
                                <tr key={res.cmnt_lineno}>
                                    <td>{(res.cmnt_createdat).split('/').reverse().join('/')}</td>
                                    <td>{res.um_username}</td>
                                    <td>{res.cmnt_desc}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </>
    )
}
export default TransactionComment;